import React from 'react';
import { Form, Header, Segment, Loader, Icon, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { fetchAcademicYears } from '../../Lookups/util';

import CoursesByYear from './CoursesByYear';
import { IconHeader } from '../ProfessorInputGrades/css';
import moment from 'moment';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class Courses extends React.Component {
    constructor(props) {
        super(props);
        let storedAcademicYearId = '';
        let storedId = '';

        if (localStorage.getItem('academicYearId')) {
            storedAcademicYearId = parseInt(localStorage.getItem('academicYearId'), 10);
        }

        if (localStorage.getItem('id')) {
            storedId = parseInt(localStorage.getItem('id'), 10);
        }

        this.state = {
            coursesByYear: [],
            academicYears: [],
            academicYearId: storedAcademicYearId,

            courseImplementationName: '',
            courseImplementationId: '',
            studentId: '',

            loaded: false,
            loadedYears: false,
            loadedStudents: false,
            id: storedId,
            excelData: []

        };

        this.getCoursesByYear = this.getCoursesByYear.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        if (this.props.location.state) {
            localStorage.setItem('id', this.props.location.state.id);
            this.setState({ id: this.props.location.state.id });
        }

        axios.all([fetchAcademicYears()])
            .then(axios.spread((res) => {
                const academicYears = res.data.reverse().map((el, index) => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ academicYears, loadedYears: true, loadedStudents: true });

                if (!localStorage.getItem('academicYearId')) {
                    axios.get('/academic-years/current')
                        .then(res => {
                            this.setState({ academicYearId: res.data.id }, () => {
                                this.getCoursesByYear(this.state.academicYearId);
                                localStorage.setItem('academicYearId', this.state.academicYearId);
                            });
                        });
                }
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch academic years');
            });


        if (localStorage.getItem('academicYearId')) {
            this.getCoursesByYear(parseInt(localStorage.getItem('academicYearId'), 10));
        }
    }


    getCoursesByYear(academicYearId) {
        if (this.props.location.pathname === '/nastavno-osoblje/predmeti') {
            axios.get((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja'))
                ? `/course/${academicYearId}/${parseInt(localStorage.getItem('id'), 10)}/${localStorage.getItem('orgUnit')}/bs`
                : `/course/${academicYearId}/${parseInt(localStorage.getItem('id'), 10)}/bs`)
                .then(res => {
                    const coursesByYear = res.data;
                    this.setState({ coursesByYear, loaded: true });
                    const excelData = res.data.map(el => ([
                        { value: el.courseImplementationName },
                        { value: el.courseNameEnglish },
                        { value: el.semesterName },
                        { value: el.courseComment ? el.courseComment : '' },
                    ]));
                    this.setState({ excelData });
                })
                .catch(err => {
                    this.setState({ error: true });
                    console.log('Failed to fetch courses');
                });
        } else {
            axios.get(`/course/for-employee/${academicYearId}/`)
                .then(res => {
                    const coursesByYear = res.data;
                    this.setState({ coursesByYear, loaded: true });
                    const excelData = res.data.map(el => ([
                        { value: el.courseImplementationName },
                        { value: el.courseNameEnglish },
                        { value: el.semesterName },
                        { value: el.courseComment ? el.courseComment : '' },
                    ]));
                    this.setState({ excelData });
                })
                .catch(err => {
                    this.setState({ error: true });
                    console.log('Failed to fetch courses');
                });
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({ loaded: false });
        this.setState({
            [name]: value
        });

        this.setState({ loadedStudents: true });
        localStorage.setItem('academicYearId', value);
        this.getCoursesByYear(value);
    }


    render() {
        const { coursesByYear } = this.state;
        return (
            <div>
                <Header as="h1">  <FormattedMessage id="common.courses" /></Header>


                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <FormattedMessage id="common.coursesList" />
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                {(localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu') && <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />}
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>

                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.loadedYears}>
                                    <label><FormattedMessage id="common.academicYear" /></label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={<FormattedMessage id="professorInputGrades.selectAcademicYear" />}
                                        value={this.state.academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>

                        </Form>


                        {!this.state.loaded && this.state.loadedStudents ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active /></div>
                            : this.state.loaded &&
                            <CoursesByYear
                                coursesByYear={coursesByYear}
                                excelData={this.state.excelData}
                                academicYearId={this.state.academicYearId}
                                professor={this.props.location.pathname === '/spisak-predmeta'}
                            />}
                    </Segment>
                </Segment.Group>


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/Courses/Courses.js